import React, { useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import "./CategoryDropdown.css";

export const predefinedModels = [
    { label: "Claude Sonnet", value: "Claude Sonnet", disabled: false },
    // { label: "Claude Opus", value: "Claude Opus", disabled: true },
    // { label: "Claude Haiku", value: "Claude Haiku", disabled: true },
    { label: "GPT-4o", value: "GPT-4o", disabled: false },
    // { label: "o1-mini", value: "o1-mini", disabled: false },
    // { label: "o3-mini", value: "o3-mini", disabled: true },
    // { label: "dall-e-3", value: "dall-e-3", disabled: true },
    // { label: "phi-4", value: "phi-4", disabled: true },
    // { label: "Stable-Diffusion-3.5-Large", value: "Stable-Diffusion-3.5-Large", disabled: true },
    // { label: "Gretel-Navigator-Tabular", value: "Gretel-Navigator-Tabular", disabled: true },
    // { label: "Llama-3.3-70B-Instruct", value: "Llama-3.3-70B-Instruct", disabled: true },
    // { label: "tsuzumi-7b", value: "tsuzumi-7b", disabled: true },
    // { label: "Ministral-3B", value: "Ministral-3B", disabled: true },
    // { label: "Virchow2", value: "Virchow2", disabled: true },
    // { label: "Virchow", value: "Virchow", disabled: true },
    // { label: "Prism", value: "Prism", disabled: true },
    // { label: "snowflake-arctic-base", value: "snowflake-arctic-base", disabled: true },
    // { label: "Deci-DeciCoder-1b", value: "Deci-DeciCoder-1b", disabled: true },
    // { label: "Deci-DeciLM-7B", value: "Deci-DeciLM-7B", disabled: true },
    // { label: "Deci-DeciLM-7B-instruct", value: "Deci-DeciLM-7B-instruct", disabled: true },
    // { label: "bin12345-autocoder", value: "bin12345-autocoder", disabled: true },
    // { label: "freedomintelligence-acegpt-v1.5-13b", value: "freedomintelligence-acegpt-v1.5-13b", disabled: true },
    // { label: "vagosolutions-llama-3.1-sauerkrautlm-70b-instruct", value: "vagosolutions-llama-3.1-sauerkrautlm-70b-instruct", disabled: true },
    // { label: "huggingfaceh4-zephyr-7b-beta", value: "huggingfaceh4-zephyr-7b-beta", disabled: true }
];

const ModelDropdown = ({ onModelChange, value = [], error, helperText }) => {
    const [selectedModels, setSelectedModels] = useState(value);

    // Predefined AI models with only GPT-4.0 enabled



    const handleModelChange = (e) => {
        setSelectedModels(e.value);
        onModelChange(e.value);
    };

    return (
        <div className="form-group">
            <label htmlFor="model">Model<span style={{ color: 'red' }}>*</span></label>
            <MultiSelect
                id="model"
                className={`p-dropdown multiselect ${error ? 'p-invalid' : ''}`} // Apply error styling
                size="small"
                value={selectedModels}
                options={predefinedModels}
                onChange={handleModelChange}
                placeholder="Select Models"
                display="chip" // Shows selected models as chips
                itemTemplate={(option) => (
                    <div className="flex items-center gap-2">
                        <span>{option.label}</span>

                    </div>
                )}
            />
            {error && <small className="p-error">{helperText}</small>} {/* Display error message */}
        </div>
    );
};

export default ModelDropdown;
